// frontend/admin-portal/src/components/dashboard/OrdersSnapshot.jsx
import React from "react";
import { Alert, Spinner, Button,Panel } from "@fiberhome/shared-ui";
import { useNavigate } from "react-router-dom";

export default function OrdersSnapshot({ slice, onViewAll }) {
  const navigate = useNavigate();
  const { data, loading, error } = slice;

  const items = [
    { key: "pending", label: "Pending", cls: "pending" },
    { key: "accepted", label: "Accepted", cls: "accepted" },
    { key: "fulfilled", label: "Fulfilled", cls: "fulfilled" },
    { key: "rejected", label: "Rejected", cls: "rejected" },
  ];

  return (
    <Panel
      title="Orders"
      subtitle="Current pipeline status"
      tone="info"
      actions={
        <Button variant="ghost" size="sm" onClick={onViewAll}>
          View all →
        </Button>
      }
    >
      {loading && (
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <Spinner size="sm" />
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}
      {!loading && !error && data && (
        <div className="d-flex flex-wrap gap-2">
          {items.map(({ key, label, cls }) => (
            <div
              key={key}
              className={`fh-orders-mini fh-orders-mini--${cls}`}
              onClick={() => navigate(`/orders?status=${key}`)}
              role="button"
              tabIndex={0}
            >
              <span className="fh-orders-mini__dot" />
              <span className="fh-orders-mini__label">{label}</span>
              <span className="fh-orders-mini__value">{data[key] ?? 0}</span>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
